module.exports = __webpack_public_path__ + "img/notify.286a5a1d.svg";